import { Badge } from "@/components/ui/badge";

const MAP = {
  attiva: { label: "Attiva", cls: "bg-green-100 text-green-800 border-green-200" },
  disattivata: { label: "Non attiva", cls: "bg-slate-200 text-slate-700 border-slate-300" },
};

export function StatoGuardiaBadge({ stato, testid }) {
  const c = MAP[stato] || MAP.disattivata;
  return (
    <Badge data-testid={testid} variant="outline" className={`${c.cls} font-medium`}>
      {c.label}
    </Badge>
  );
}

const VERBALE = {
  "In corso": "bg-amber-100 text-amber-800 border-amber-200",
  Verificato: "bg-blue-100 text-blue-800 border-blue-200",
  "Trasmesso ASL/Procura": "bg-[#14382C] text-white border-[#14382C]",
  Archiviato: "bg-slate-200 text-slate-700 border-slate-300",
};

export function StatoVerbaleBadge({ stato }) {
  return (
    <Badge variant="outline" className={`${VERBALE[stato] || "bg-slate-100"} font-medium`}>
      {stato}
    </Badge>
  );
}

export function ScadenzaBadge({ giorni }) {
  if (giorni === null || giorni === undefined)
    return <span className="text-slate-400 text-sm">Non impostata</span>;
  let cls = "bg-green-100 text-green-800 border-green-200";
  let label = `Tra ${giorni} gg`;
  if (giorni < 0) {
    cls = "bg-red-100 text-red-800 border-red-200";
    label = `Scaduto da ${Math.abs(giorni)} gg`;
  } else if (giorni <= 30) {
    cls = "bg-amber-100 text-amber-800 border-amber-200";
  }
  return <Badge variant="outline" className={`${cls} font-medium`}>{label}</Badge>;
}
